import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '@material-ui/core/Modal';
import Badge from '@material-ui/core/Badge';
import { AiOutlineLogout } from 'react-icons/ai';
import { useGoogleLogout } from 'react-google-login';
import { FiUser, FiMail, FiPhone, FiMenu, } from 'react-icons/fi';
import { NotificationsOutlined, Clear } from '@material-ui/icons';

import { StoreState } from '../../store/createStore';
import { customerClear, signOut } from '../../store/modules/auth/actions';
import { useTranslation } from '../../hooks/useTranslation';
import { openMenuBase, openShowModal, viewModal, } from '../../store/modules/parameter/actions';
import SignIn from '../../pages/SignIn';
import { useNotification } from '../../hooks/notification';
import {
  Container,
  ContainerMenuMobile,
  Button,
  ContainerLeft,
  ContainerRight,
  Item,
  Root,
  SelectContainer,
  ContainerContent,
  RenderNotificationItem,
  ContainerModal
} from './styles';
import { toast } from 'react-toastify';
import { routesEndpoints } from '../../routes/endpoint';
import MultiStoreSelected from '../../components/MultiStoreSelected';
import { useAuth } from '../../hooks/auth';
import { config } from '../../config';

const NavBar: React.FC = () => {
  const locaion = useLocation();
  const { signOut: onSignout } = useAuth();
  const [open, setOpen] = React.useState(false);
  const { notification, deleteNotification, deleteAllNotification } = useNotification();
  const { onTranslation: t } = useTranslation();
  const dispatch = useDispatch();
  const googleLogout = useGoogleLogout({
    clientId:
      '190075581551-7ogbkj0eqeqjo1ommuk0gb53142eqmqa.apps.googleusercontent.com',
  });
  const { isSignedIn, isLoginInGoogle, user: { data } } = useSelector((state: StoreState) => state.auth);
  const { multistoreSelected } = useSelector((state: StoreState) => state.parameter);

  const handleOpen = () => {
    if (notification?.length !== 0) {
      setOpen(true);
    } else {
      toast.info(t('main.messages_toast.there_are_no_notifications'), {
        position: 'top-right',
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handledOpenMenu = useCallback(() => {
    dispatch(openMenuBase());
  }, [dispatch]);

  const handledOpenModal = useCallback(() => {
    dispatch(customerClear());
    dispatch(openShowModal(true));
    dispatch(viewModal(SignIn, { width: '50%', height: '100%' }));
  }, [dispatch]);

  const handledLogout = useCallback(() => {
    dispatch(signOut());
    onSignout();
    if (isLoginInGoogle)
      googleLogout.signOut();
    // history.push(routesEndpoints.HOME);
  }, [dispatch, googleLogout, isLoginInGoogle, onSignout]);

  const handleDeleteNotification = useCallback((messageId: string) => {
    deleteNotification(messageId);
  }, [deleteNotification]);

  return (
    <Root>
      <Container>
        <ContainerMenuMobile>
          <div>
            <Button onClick={handledOpenMenu}>
              <FiMenu size={24} color="#FFF" />
            </Button>
          </div>
        </ContainerMenuMobile>

        <ContainerLeft>
            {
              multistoreSelected.phone && multistoreSelected.phone.length > 0 && (
                <div>
                  <FiPhone />
                  {multistoreSelected.phone}
                </div>
              )
            }
            {
              config.isShowEmailStore && multistoreSelected.email && multistoreSelected.email.length > 0 && (
                <div>
                  <FiMail />
                  {multistoreSelected.email}
                </div>
              )
            }
        </ContainerLeft>
              {
                locaion.pathname !== routesEndpoints.NEW_CHECKOUT &&
                <MultiStoreSelected />
              }
        <ContainerRight>
          <SelectContainer>

            <div className='alertNotification'>
              <Badge
                badgeContent={notification?.length}
                color="secondary"
                style={{ cursor: 'pointer' }}
                onClick={handleOpen}
                overlap='rectangular'
              >
                <NotificationsOutlined />
              </Badge>
            </div>

          </SelectContainer>

          <Item>
            {isSignedIn ? (
              <Button id="button-action-login" onClick={!isSignedIn ? handledOpenModal : handledLogout}>
                <FiUser />
                <span style={{ marginRight: '6px' }}>
                  {`${data.first_name} ${data.last_name}`}
                </span>
                <AiOutlineLogout />
              </Button>
            ) : (
              <>
                <Button onClick={!isSignedIn ? handledOpenModal : handledLogout}>
                  <FiUser />
                  {t('main.navbar.enter_and_register')}
                </Button>
              </>
            )}
          </Item>
        </ContainerRight>
      </Container>

      <ContainerModal>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          open={open}
          onClose={handleClose}
          closeAfterTransition
        >

          <ContainerContent>
            <div className='containerButtons'>
              <button onClick={deleteAllNotification}>
                Limpar tudo
                <Clear />
              </button>

              <button
                onClick={handleClose}
                className='buttonClose'
              >
                <Clear />
              </button>
            </div>

            <section>
              {
                notification.length > 0 ? (
                  <>
                    {
                      notification.map((item, index) => (
                        <RenderNotificationItem
                          key={index}
                        >
                          <div className='notificationContent'>

                            <div>
                              <h1>{item.notification.title}</h1>
                              <p>{item.notification.body}</p>
                            </div>

                            <img src={item.notification.image} alt="" />
                          </div>

                          <button onClick={() => handleDeleteNotification(item.messageId)}>
                            Excluir
                            <Clear />
                          </button>
                        </RenderNotificationItem>
                      )
                      )
                    }
                  </>
                ) : <></>
              }
            </section>
          </ContainerContent>
        </Modal>
      </ContainerModal>
    </Root>
  );
};

export default NavBar;
